import run from '../../../utilities/run';
import render from "../../../utilities/render";
import SubmitModalFlow from "../../../components/SubmitModalFlow/SubmitModalFlow";
import { setElementsFromScope } from "../../../utilities/selectorHelpers";
import moment from "moment";
require("./podAdvancedShipmentForm.less");

const targetSelector = "#searchShipment";

run(targetSelector, () => {
  const $ = require('jquery');
  const search_url = $(targetSelector).data("search-url");
  const errorflag = $(targetSelector).data("errorflag");
  let status = $(targetSelector).data("status");
  let carrier = $(targetSelector).data("carrier");
  let shipper = $(targetSelector).data("shipper");
  let country = $(targetSelector).data("country");
  let model_data = $(targetSelector).data("model");
  let result_size = $(targetSelector).data("result-size");

  const elementsMap = {
    advancedSearchBtn: ".advanced-search-btn",
    shpCarrier: "#shpCarrier",
    shpStatus: "#shpStatus",
    ShipperOptions: "#shpMerchantBuId",
    shpShipToCountry: "#shpShipToCountry"
  };

  const els = {};

  const entryEl = $("<div class='entry-point'></div>");

  const mainHtml = render(
    require("./html/podAdvancedShipmentForm.html")
  );

  const mainEl = $(mainHtml);
  $(targetSelector).html(entryEl);
  entryEl.append(mainEl);

  let submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();

  function init() {
    setElements();
    generateDatePickers();
    loadDropDowns();
    setValues();
  }

  function setElements() {
    setElementsFromScope(els, elementsMap, mainEl);
  }

  function generateDatePickers() {

    const date = new Date();
    const shipFromDate = $("#shpShipFromDate");
    const shipToDate = $("#shpShipToDate");
    const dueFromDate = $("#shpDueFromDate");
    const dueToDate = $("#shpDueToDate");

    shipFromDate.datepicker({
      endDate: date,
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });

 shipToDate.datepicker({
      endDate: date,
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });


    dueFromDate.datepicker({
      endDate: date,
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });

    dueToDate.datepicker({
      endDate: date,
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });


  }
  function loadDropDowns() {
    let shpCarrier = carrier.map(function (val) {
      return $("<option></option>").html(val.carrier);
    });
    els.shpCarrier.append(shpCarrier);

    let shpStatus = status.map(function (val) {
      return $("<option></option>").html(val.status);
    });
    els.shpStatus.append(shpStatus);

    let ShipperOptions = shipper.map(function (val) {
      return $("<option></option>").html(val.shipper);
    });
    els.ShipperOptions.append(ShipperOptions);

    let shpShipToCountry = country.map(function (val) {
      return $("<option></option>").html(val.conCode);
    });
    els.shpShipToCountry.append(shpShipToCountry);
  }

  function setValues() {
  }

  $(targetSelector).validate({
    errorPlacement: function (error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  });

  $("#searchBtn").on("click", function () {
    if($("#shpShipFromDate").val() !=="" && $("#shpShipToDate").val()=== ""){
      if ($(targetSelector).valid()) {
       const sendShipToDate = moment(new Date()).format("MM/DD/YYYY");
      $("#shpShipToDate").val(sendShipToDate);
      $(targetSelector).submit();
      submitModalFlow.showLoadingModal();
        }
    }
    else if($("#shpShipFromDate").val()==="" && $("#shpShipToDate").val()!==""){
     if ($(targetSelector).valid()) {
      const sendShipFromDate=moment($("#shpShipToDate").val()).subtract(1, 'months').format("MM/DD/YYYY");
      $("#shpShipFromDate").val(sendShipFromDate);
      $(targetSelector).submit();
      submitModalFlow.showLoadingModal();
      }
    }
    else if($("#shpDueFromDate").val() !=="" && $("#shpDueToDate").val()=== ""){
      if ($(targetSelector).valid()) {
       const sendDueToDate = moment(new Date()).format("MM/DD/YYYY");
      $("#shpDueToDate").val(sendDueToDate);
      $(targetSelector).submit();
      submitModalFlow.showLoadingModal();
        }
    }else if($("#shpDueFromDate").val()==="" && $("#shpDueToDate").val()!==""){
     if ($(targetSelector).valid()) {
      const sendDueFromDate=moment($("#shpDueToDate").val()).subtract(1, 'months').format("MM/DD/YYYY");
      $("#shpDueFromDate").val(sendDueFromDate);
      $(targetSelector).submit();
      submitModalFlow.showLoadingModal();
      }
    }
    else{
    if ($(targetSelector).valid()) {
      $(targetSelector).submit();
      submitModalFlow.showLoadingModal();
      }
    }
  });

  //Error message Loading
  if (result_size == 0 && errorflag) {
    const ErrorHtml = require("./html/errorDisplay.html");
    $("#errordisplay").html(render(ErrorHtml));
  }

  init();
});



// WEBPACK FOOTER //
// ./src/pages/proofOfDelivery/podAdvancedShipmentForm/shipmentForm.js